<div (click)="onClick($event)">
  <div class="da-list-wrap">
    <div class="da-content-wrapper">
      <da-layout-row [daGutter]="[24, 24]">
          <da-col-item [daSpan]="24" [daXs]="24">
              <div class="da-list-container">
                  <div class="da-list-header">
                      <div class="da-common-search">
                          <div class="da-left">
                              <d-search [size]="'sm'" (searchFn)="getList()" [(ngModel)]="_search.full_name" class="da-inline" [placeholder]="'Tìm tên người dùng'"></d-search>
                              <d-button (click)="reset()" style="margin-left: 12px">Reset</d-button>

                              <input style="margin-left: 12px" type="checkbox" [ngModel]="isCheckAll" (ngModelChange)="checkAll($event)"> Chọn tất cả

                              <!-- <d-button style="margin-left: 12px" (click)="onCheckAllChange()">Chọn tất cả</d-button> -->
                              <!-- <d-button class="btn btn-primary" (click)="addRow()" style="margin-left: 12px">Thêm</d-button> -->
                            </div>
                          <div class="da-right">
                            <d-button style="margin-right:10px" (click)="save()">Lưu</d-button>

                          </div>
                      </div>
                  </div>
                  <br />
                  <div class="list-content" dLoading [loading]="busy">
                      <d-data-table
                      [dataSource]="basicDataSource" 
                      [borderType]="searchForm.borderType"
                      [tableWidthConfig]="tableWidthConfig"
                      [tableLayout]="searchForm.layout" 
                      (checkAllChange)="onCheckAllChange()"
                      [lazy]="true"
                      [scrollable]="true">
                      <thead dTableHead>
                        <tr dTableRow>
                          <th></th>
                          <th
                            dHeadCell
                            *ngFor="let colOption of dataTableOptions.columns"
                          >
                            {{ colOption.header }}
                          </th>
                        </tr>
                      </thead>
                      <tbody dTableBody>
                        <ng-template let-rowItem="rowItem" let-rowIndex="rowIndex" let-nestedIndex="nestedIndex">
                          <tr dTableRow [ngClass]="{ 'da-table-row-selected': rowItem.$checked }">
                            <td dTableCell class="devui-checkable-cell">
                                
                              <d-checkbox
                                [ngModel]="users_checked[rowItem.user_rcd]"
                                (ngModelChange)="changeCheckBox($event,rowItem.user_rcd)"
                                dTooltip
                                [position]="['top', 'right', 'bottom', 'left']"
                                [showAnimation]="false"
                              >
                              </d-checkbox>
                              <!-- <input type="checkbox" checked="{{isCheck(rowItem.user_rcd)}}" (ngModelChange)="changeCheckBox($event,rowItem.user_rcd)"> -->
                            </td>
                            <td
                              dTableCell
                              [rowItem]="rowItem"
                              [field]="'full_name'"
                            ><span>{{ rowItem?.full_name }}</span></td>
                            <td
                              dTableCell
                              [rowItem]="rowItem"
                              [field]="'gender'"
                            ><span>{{ rowItem?.gender }}</span></td>
                            <td
                              dTableCell
                              [rowItem]="rowItem"
                              [field]="'date_of_birth'"
                            ><span>{{ rowItem?.date_of_birth }}</span></td>
                            <td
                              dTableCell
                              [rowItem]="rowItem"
                              [field]="'phone_number'"
                            ><span>{{ rowItem?.phone_number }}</span></td>
                            <td
                              dTableCell
                              [rowItem]="rowItem"
                              [field]="'user_name'"
                            ><span><d-tag [tag]="rowItem?.user_name"></d-tag></span></td>
                            <td
                              dTableCell
                              [rowItem]="rowItem"
                              [field]="'role_name_l'"
                            ><span>{{ rowItem?.role_name_l }}</span></td>
                          </tr>
                        </ng-template>
                      </tbody>
                          <!-- <d-column header="STT" [width]="'100px'">
                              <d-cell>
                                  <ng-template let-rowIndex="rowIndex">
                                      {{ rowIndex + 1 }}
                                  </ng-template>
                              </d-cell>
                          </d-column>
                          <d-column field="full_name" header="Tên người dùng" [width]="'150px'">
                              <d-cell>
                                  <ng-template let-cellItem="cellItem">
                                      <span [title]="cellItem" class="over-flow-ellipsis" [style.width]="'150px'">
                                        {{ cellItem }}
                                      </span>
                                  </ng-template>
                              </d-cell>
                          </d-column>
                          <d-column field="gender" header="Giới tính" [width]="'100px'">
                              <d-cell>
                                  <ng-template let-cellItem="cellItem">
                                      {{ cellItem }}
                                  </ng-template>
                              </d-cell>
                          </d-column>
                          <d-column field="date_of_birth" header="Ngày sinh" [width]="'100px'">
                              <d-cell>
                                  <ng-template let-cellItem="cellItem">
                                      {{ cellItem }}
                                  </ng-template>
                              </d-cell>
                          </d-column>
                          <d-column field="phone_number" header="Số điện thoại" [width]="'100px'">
                              <d-cell>
                                  <ng-template let-cellItem="cellItem">
                                      <d-tag [tag]="cellItem" [labelStyle]="cellItem"></d-tag>
                                  </ng-template>
                              </d-cell>
                          </d-column>
                          <d-column field="user_name" header="Tên đăng nhập" [width]="'100px'">
                                  <d-cell>
                                      <ng-template let-cellItem="cellItem">
                                          <d-tag [tag]="cellItem" [labelStyle]="cellItem"></d-tag>
                                      </ng-template>
                                  </d-cell>
                          </d-column>
                          <d-column field="role_name_l" header="Quyền" [width]="'100px'">
                                  <d-cell>
                                      <ng-template let-cellItem="cellItem">
                                          {{ cellItem }}
                                      </ng-template>
                                  </d-cell>
                          </d-column> -->
                      </d-data-table>
                  </div>
                  <div class="da-list-footer">
                      <d-pagination [size]="'sm'" [total]="pager.total" [(pageSize)]="pager.pageSize" [(pageIndex)]="pager.pageIndex" [canViewTotal]="true" [canChangePageSize]="true" [canJumpPage]="true" [maxItems]="5" (pageIndexChange)="onPageChange($event)" (pageSizeChange)="onSizeChange($event)">
                      </d-pagination>
                  </div>
              </div>
          </da-col-item>
      </da-layout-row>
  </div>
  </div>
</div>
